import { FilterDropdown, ListComponent, StatusComponent } from 'containers/backend/common/component/Index'
import React, { Fragment, useEffect } from 'react'
import * as Func from 'helpers/functions';
import { FlagIcons } from 'containers/backend/common/component/TranslateButton';
import DEFINE, { TRANSLATE_LANGUAGE } from 'constants/Define';
import { toArray } from 'lodash';
import EditComponent from './components/CommonComponent';
import {screenTypeEnum} from 'constants/Define'
import { Icon } from 'antd';

const ListCols = ['id', 'backgroundImage','backgroundName','screenTypes','isDisplay','order','translations']

const AppUIList = (props) => {
    //! State
    const {isLoading, listAppUI, paging, onChangeTable, permissionActions} = props;
    const titleItemTable = Func.getTitleTable(ListCols, ['action'],['id','voucherType']);
    const componentTable = {
        backgroundImage: {
            key: "backgroundImage",
            width: 300,
            render: (text, record) => {
                return(
                    <Fragment>
                        <img style={{width:'100%'}} src={getThumbSources(text?.fileUri)} alt={text.filename}/>
                    </Fragment>
                )
            }
        },
        backgroundName: {
            align: 'center',
            key: "backgroundName",
            render: (text, record) => (text || record.title),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <FilterDropdown
                    setSelectedKeys={setSelectedKeys}
                    selectedKeys={selectedKeys}
                    confirm={confirm}
                    clearFilters={clearFilters}
                >
                </FilterDropdown>
            ),
            filterIcon: filtered => (
                <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
        },
        screenTypes: {
            align: 'center',
            title: props.t('item.app.screen'),
            key: "screenTypes",
            render: (value, record) => (screenTypeEnum?.find(el => el.value === record?.screenType)?.text),
            filters: [
                {value: 1, text: props.t('item.app.welcome')},
                // {value: 2, text: props.t('item.app.home')},
                {value: 3, text: props.t('item.app.topic_home')}
            ],
            // filterMultiple: false
        },
        isDisplay: {
            key: "isDisplay",
            align: 'center',
            title: props.t('item.app.status'),
            render: (isDisplay) => <StatusComponent color={isDisplay ? 'green' : 'red'}
                label={isDisplay ? props.t('item.app.isDisplay') : props.t('item.app.isUnDisplay')} />,
            filters: [
                {value: true, text: props.t('item.app.isDisplay')},
                {value: false, text: props.t('item.app.isUnDisplay')}
            ],
            filterMultiple: false
        },
        order: {
            align: "center",
            key: "order",
            sorter: (a, b) => a.order - b.order
        },
        translations: {
            align: "center",
            render: (text, record) => <FlagIcons languages={record.translations} />,
            key: 'languageCode',
            filters: toArray(TRANSLATE_LANGUAGE).map(lang => ({
                value: lang.code, text: props.t(`translate.languages.${lang.id}`)
            })),
            filterMultiple: false,
        },
        action: {
            key: "action",
            align: "action",
            // fixed: 'right',
            width: 100,
            render: (text, record) => <EditComponent item={record} permissionActions={permissionActions}
                    deleteAppUIConfig={props.deleteAppUIConfig}/>,
        }

    };
    //! Function
    const getThumbSources = (image) => {
        return image ? [`${DEFINE.GENERAL.CDN_IMG_DEFAULT}${image}`] : [];
    }
    //! Effect
    
    //! Render
  return (
    <ListComponent
        tableKey="appUI-list"
        classChildren="p-0" classParent="m-0"
        rowKey={(record, k) => record.id ? record.id : k}
        loading={{ spinning: isLoading, size: 'large' }}
        dataSource={listAppUI}
        // scroll={{ x: 2650 }}
        onChange={onChangeTable}
        columns={Func.columnsTable({
            titleTable: titleItemTable,
            component: componentTable,
            itemName: 'app'
        })}
        pagination={{ total: paging.current.totalCount, pageSize: paging.current.pageSize, current: paging.current.pageIndex}}
    />
  )
}

export default AppUIList